import {
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import classes from "../../../css/modules/projects.module.scss";
import { apiUrls } from "../../../utils/api";
import { routes } from "../../../utils/constants";
import { useDispatch } from "react-redux";
import { snackbar } from "../../../redux/snackbar";
import { useApiClient } from '../../../components/ApiProvider';

const importTypes = {
  project: "1",
  order: "2",
};

const useStyles = makeStyles(() => ({
  actionButtonColor: {
    backgroundColor: "#5388E1",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#3F6AB6",
    },
  },
}));

export function NewProjectBtn() {
  const { t } = useTranslation();
  const history = useHistory();
  const btnStyles = useStyles();
  const [modalNewProject, setModalNewProject] = useState(false);
  const toggleModalNewProject = () => setModalNewProject(!modalNewProject);
  const [newProjectRidderProjectNumber, setNewProjectRidderProjectNumber] = useState("");
  const [importEnabled, setImportEnabled] = useState(true);
  const dispatch = useDispatch();
  const apiClient = useApiClient();

  const CreateProjectOnServer = async () => {
    if (!newProjectRidderProjectNumber) {
      dispatch(
        snackbar.actions.add({
          id: "CreateNewProjectSnack",
          severity: "info",
          message: "Please fill the number",
        })
      );     
      return;
    }
    setImportEnabled(false);
    dispatch(
      snackbar.actions.add({
        id: "CreateNewProjectSnack",
        severity: "info",
        message: "Creating project...",
        showCircularProgress: true,
      })
    );

    const requestUrl = value === importTypes.project ? apiUrls.CreateNewProject : apiUrls.CreateNewOrderAsProject;

    const stream = await apiClient.post(requestUrl, undefined, {
      newProjectRidderProjectNumber: newProjectRidderProjectNumber,
    });
    const { newProjectNumber, error } = await stream.json();
    let translatedError = t("ProjectCanNotBeImported");
    if (error === "") {
      translatedError = translatedError + t("UnknownError");
    } else {
      translatedError = translatedError + t(error);
    }

    if (newProjectNumber > 0) {
      dispatch(
        snackbar.actions.add({
          id: "CreateNewProjectSnack",
          severity: "success",
          message: "Created project!",
          showCircularProgress: false,
          autoHideDuration: 4000,
        })
      );
      history.push(routes.project.replace(":id", newProjectNumber));
    } else {
      dispatch(
        snackbar.actions.add({
          id: "CreateNewProjectSnack",
          severity: "error",
          message: translatedError,
          showCircularProgress: false,
        })
      );
    }
    setImportEnabled(true);
  };
  const [value, setValue] = useState(importTypes.project);
  const onTypeChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  return <>
    <button data-testid="import-project-button" className={classes.newProjectBtn} onClick={toggleModalNewProject}>
      <span className="ico icon-folder-plus" />
      {t("Import project")}
    </button>
    <Dialog
      fullWidth
      maxWidth="xl"
      open={modalNewProject}
      onClose={toggleModalNewProject}
      className={classes.addProjectDialog}
    >
      <h2 className={classes.dialogTittle}>{t("Import project/order")}</h2>
      <DialogContent className={classes.dialogContent}>
        <RadioGroup
          value={value}
          row
          aria-label="position"
          name="position"
          className={classes.radioGroup}
          onChange={onTypeChange}
        >
          <FormControlLabel
            value={importTypes.project}
            control={<Radio size="small" color="primary" data-testid="project-radio-button" />}
            label="Project"
            labelPlacement="start"
          />
          <FormControlLabel
            value={importTypes.order}
            control={<Radio size="small" color="primary" data-testid="order-radio-button"  />}
            label={t("Order number")}
            labelPlacement="start"
          />
        </RadioGroup>
        <br />
        <TextField
          size="small"
          fullWidth
          autoFocus
          variant="outlined"
          placeholder={value === importTypes.project ? t("Project number") : t("Order number")}
          value={newProjectRidderProjectNumber}
          onChange={(e) => setNewProjectRidderProjectNumber(e.target.value)}
        />
        <div className={classes.dialogBtns}>
          <Button variant="text" size="medium" onClick={toggleModalNewProject}>
            {t("Cancel")}
          </Button>
          <Button
            data-testid="create-project-button"
            variant="contained"
            size="medium"
            className={btnStyles.actionButtonColor}
            onClick={CreateProjectOnServer}
            disabled={!importEnabled}
          >
            {t("Create project!")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  </>;
}
